<template>
  <div>
    <header data-v-58d612c2="" role="tab" class="card-header">
      <h6 data-v-58d612c2="" class="m-0">
        E-mails
      </h6>
    </header>
    <div class="row notif-scroll">
      <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
      </loading>
      <div class="col-lg-12">
        <div v-if="!mails || mails.length === 0" class="text-muted py-3 text-center font-size-12">
          Nenhum e-mail registrado para este participante.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead style="border: none !important">
              <tr>
                <th width="32%" style="border-top: none !important">Tipo</th>
                <th width="12%" style="border-top: none !important">Origem</th>
                <th width="13%" style="border-top: none !important">Entrega</th>
                <th width="13%" style="border-top: none !important">Leitura</th>
                <th width="12%" style="border-top: none !important">Falha</th>
                <th width="9%" style="border-top: none !important">Abriu</th>
                <th width="9%" style="border-top: none !important">Clicou</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="mail in mails" :key="mail.id">
                <td class="cell-type" :title="mail.typeEmail">{{ mail.typeEmail }}</td>
                <td>
                  <span
                    class="wa-source-badge"
                    :class="`wa-source-${mail.source || 'manual'}`"
                  >{{ sourceLabel(mail.source) }}</span>
                </td>
                <td class="font-size-11">
                  {{ mail.delivered_at ? $moment(mail.delivered_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
                <td class="font-size-11">
                  {{ mail.opened_at ? $moment(mail.opened_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
                <td class="font-size-11">
                  {{ mail.failed_at ? $moment(mail.failed_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
                <td>{{ mail.opened }}</td>
                <td>{{ mail.clicked }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <header data-v-58d612c2="" role="tab" class="card-header">
      <h6 data-v-58d612c2="" class="m-0">
        Mensagens Whatsapp
      </h6>
    </header>
    <div class="row notif-scroll">
      <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
      </loading>
      <div class="col-lg-12">
        <div v-if="!waMessages || waMessages.length === 0" class="text-muted py-3 text-center font-size-12">
          Nenhuma mensagem WhatsApp registrada para este participante.
        </div>
        <div v-else class="table-responsive">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th width="35%" style="border-top: none !important">Tipo</th>
                <th width="12%" style="border-top: none !important">Origem</th>
                <th width="13%" style="border-top: none !important">Envio</th>
                <th width="13%" style="border-top: none !important">Entrega</th>
                <th width="13%" style="border-top: none !important">Leitura</th>
                <th width="13%" style="border-top: none !important">Falha</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="wa in waMessages" :key="wa.id">
                <td class="cell-type" :title="wa.title">{{ wa.title }}</td>
                <td>
                  <span
                    class="wa-source-badge"
                    :class="`wa-source-${wa.source || 'manual'}`"
                  >{{ sourceLabel(wa.source) }}</span>
                </td>
                <td class="font-size-11">
                  {{ wa.sent_at ? $moment(wa.sent_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
                <td class="font-size-11">
                  {{ wa.delivered_at ? $moment(wa.delivered_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
                <td class="font-size-11">
                  {{ wa.read_at ? $moment(wa.read_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
                <td class="font-size-11">
                  {{ wa.failed_at ? $moment(wa.failed_at).format('DD/MM/YYYY HH:mm') : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions } from 'vuex'

export default {
  components: {
    Loading
  },
  props: {
    idParticipant: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      mails: [],
      waMessages: [],
      statusClass: ['dark', 'primary', 'warning', 'success', 'danger']
    }
  },
  mounted () {
    this.getMessages()
  },
  beforeMount () {
    this.GetMails(this.idParticipant).then((res) => {
      this.mails = res
      this.loading = false
    }).catch(error => {
      console.log(error)
      this.loading = false
    })
  },
  methods: {
    ...mapActions('participant', {
      GetMails: 'getAllMails',
      GetMessages: 'getAllWAMessages'
    }),
    getMessages () {
      this.GetMessages(this.idParticipant).then((res) => {
        this.waMessages = res
      }).catch(error => {
        console.log(error)
      })
    },
    sourceLabel (source) {
      if (source === 'campaign') return 'Campanha'
      if (source === 'status_change') return 'Status'
      return 'Manual'
    }
  }
}
</script>
<style scoped>
.menu-notifications {
  display: flex;
  gap: 1rem;
}

/* Badge de origem da mensagem WhatsApp.
   campaign  → roxo (mesmo tom do cross-field do dashboard)
   status_change → azul (transacional)
   manual    → cinza (genérico/legado) */
.wa-source-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 99px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}
.wa-source-campaign {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}
.wa-source-status_change {
  background: rgba(85, 110, 230, 0.1);
  color: #556ee6;
}
.wa-source-manual {
  background: #f0f1f6;
  color: #4a5068;
}

/* Truncate da coluna "Tipo" — campanhas com nomes longos viram "Lorem ipsum…"
   sem quebrar linha nem forçar scroll horizontal. Tooltip nativo (atributo
   title) mostra o nome completo no hover. */
.cell-type {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Scroll fino estilo /participant-card-builder — 6px, cinza claro,
   trilho transparente, suaviza no hover. */
.notif-scroll {
  max-height: 400px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}
.notif-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.notif-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.notif-scroll::-webkit-scrollbar-thumb {
  background-color: #d0d5dd;
  border-radius: 3px;
}
.notif-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #b0b5bd;
}
</style>
